import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useChangeMantenanceEntity } from "src/services/admin/commands/entities";
import SnackbarUtils from "src/utils/SnackbarUtils";

const useModifyMaintanance = (onClose: (isSuccess?: boolean) => void) => {
	const [isLoading, setIsLoading] = useState(false);

	const { mutate } = useChangeMantenanceEntity();
	const queryClient = useQueryClient();

	const onSuccess = () => {
		setIsLoading(false);
		SnackbarUtils.success("La entidad ya se ha modificado.");
		onClose(true);
		queryClient.refetchQueries({ queryKey: ["organization", "users"] });
	};

	const onError = () => {
		SnackbarUtils.error("Se ha producido un error al intentar modificar la entidad.");
		onClose();
		setIsLoading(false);
	};

	const changeEntity = (entityId: string, maintenance: boolean) => {
		setIsLoading(true);
		mutate({ entityId, maintenance }, { onSuccess, onError });
	};

	return {
		changeEntity,
		isLoading
	};
};

export default useModifyMaintanance;
